<script lang="ts">
  import ScoresTable from './ScoresTable.svelte';
  import Leaderboard from './Leaderboard.svelte';

  export let scoresAndRewards;
  export let activeUser;
  export let leaderboard;
  
  let show: 'scores' | 'leaderboard' = 'scores';
</script>

<div>
  <div class="sm:hidden">
    <label for="tabs" class="sr-only">Select a tab</label>
    <select bind:value={show} id="tabs" name="tabs" class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md">
      <option value='scores' selected={show === 'scores'}>My scores</option>
      <option value='leaderboard' selected={show === 'leaderboard'}>Leaderboard</option>
    </select>
  </div>
  <div class="hidden sm:block">
    <nav class="relative z-0 rounded-lg shadow flex divide-x divide-gray-200" aria-label="Tabs">
      <!-- Current: "text-gray-900", Default: "text-gray-500 hover:text-gray-700" -->
      <span class="cursor-pointer rounded-l-lg group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
            class:text-gray-900={show === 'scores'}
            class:text-gray-500={show !== 'scores'}
            class:hover:text-gray-700={show !== 'scores'}
            on:click={() => show='scores'}
            aria-current={(show === 'scores' ? 'page' : undefined)}>
        <span>My Scores</span>
        <span aria-hidden="true" class="absolute inset-x-0 bottom-0 h-0.5"
              class:bg-indigo-500={show === 'scores'}
              class:bg-transparent={show !== 'scores'}></span>
      </span>

      <span class="cursor-pointer rounded-r-lg group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
            class:text-gray-900={show === 'leaderboard'}
            class:text-gray-500={show !== 'leaderboard'}
            class:hover:text-gray-700={show !== 'leaderboard'}
            on:click={() => show='leaderboard'}
            aria-current={(show === 'leaderboard' ? 'page' : undefined)}>
        <span>Leaderboard</span>
        <span aria-hidden="true"
              class="absolute inset-x-0 bottom-0 h-0.5"
              class:bg-indigo-500={show === 'leaderboard'}
              class:bg-transparent={show !== 'leaderboard'}></span>
      </span>

    </nav>
  </div>
</div>

{#if scoresAndRewards && show === 'scores'}
  <!-- <div class="text-2xl pt-5 pb-2 font-bold text-center">My scores</div> -->
  <ScoresTable scoresAndRewards={scoresAndRewards} />
{/if}

{#if leaderboard && show === 'leaderboard'}
  <!-- <div class="text-2xl pt-5 pb-2 font-bold text-center">Leaderboard</div> -->
  <Leaderboard activeUser={activeUser} values={leaderboard} />
{/if}
